import { request } from '@langlois/request';

export async function deleteEvent ({ commit, dispatch }, eventId) {
	try {
		const url = new URL(`${process.env.VUE_APP_API_URI}/club/competition-event/${eventId}`);

		const response = await request.delete(url);

		if (response.ok) {
			dispatch(`closeForm`);

			return commit(`deleteEvent`, eventId);
		}

		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while deleting the event.`,
			type: `warning`
		}, { root: true });
	} catch (error) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while deleting the event.`,
			type: `warning`
		}, { root: true });
	}
}
